import React from "react";

import FilterSkeleton from "./FilterSkeleton";
import GroupedCheckboxList from "./GroupedCheckboxList";

import { Box } from "@bca/ui-library";
import FilterAsCheckbox from "./FilterAsCheckbox";
import prepareFiltersForApiCall from "./prepareFiltersForApiCall";

const CheckboxGroup = ({
  filteredSubfilters,
  categoryKey,
  parentFilterKey,
  appliedCheckboxes,
  setAppliedCheckboxesCheckBoxGroup,
  updateAdditionalFilters,
  additionalFilters,
}) => {
  return (
    <>
      {!filteredSubfilters && <FilterSkeleton pairCount={3} />}
      {filteredSubfilters?.map(({ filterKey, filterValues }) => {
        if (filterValues?.length === 1 && filterValues[0].name === filterKey) {
          const onChange = () => {
            const updatedAppliedCheckboxes = setAppliedCheckboxesCheckBoxGroup(
              filterKey,
              categoryKey,
              "",
              parentFilterKey
            );
            const newUrl = prepareFiltersForApiCall(
              "bq",
              updatedAppliedCheckboxes,
              additionalFilters
            );
            updateAdditionalFilters({
              bq: newUrl.searchParams.get("bq") || "",
            });
          };
          return (
            <Box key={filterKey}>
              <FilterAsCheckbox
                key={filterKey}
                id={filterKey}
                label={filterKey}
                resultsCount={filterValues[0].count}
                isSelected={Boolean(
                  appliedCheckboxes.find(
                    (item) =>
                      item.filterKey === filterKey &&
                      item.categoryKey === categoryKey
                  )
                )}
                onChange={onChange}
              />
            </Box>
          );
        }

        return (
          <GroupedCheckboxList
            key={`${categoryKey}-${filterKey}`}
            filterKey={filterKey}
            categoryKey={categoryKey}
            filterValues={filterValues}
            setAppliedCheckboxesCheckBoxGroup={
              setAppliedCheckboxesCheckBoxGroup
            }
            selectedCheckboxes={appliedCheckboxes}
            parentFilterKey={parentFilterKey}
            additionalFilters={additionalFilters}
            updateAdditionalFilters={updateAdditionalFilters}
          />
        );
      })}
    </>
  );
};

export default CheckboxGroup;
